import { useMutation } from '@northladder/services';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the user language change mutation keys in react query cache.
 */
const UPDATE_USER_LANGUAGE = 'update-user-language-mutation-key';

/**
 * This performs Notification viewed api call and update the state using query
 *  client
 */
export const useUpdateLanguageMutation = () => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [UPDATE_USER_LANGUAGE],
    retry: false,
    mutationFn: USER_ACCOUNTS_API.updateUserLanguage,
  });

  return {
    error,
    isPending,
    mutate,
  };
};
